module.exports = __webpack_public_path__ + "static/media/IntroAWP.dd6ad874.jpg";